export default __webpack_public_path__ + "static/char-v-52-47e6e441ab4a77632728b8e21310be4e.png";